import { render, staticRenderFns } from "./CardClientMessage.vue?vue&type=template&id=d9cfa75e"
import script from "./CardClientMessage.vue?vue&type=script&lang=js"
export * from "./CardClientMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports